module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal-user-details-page personal-user-details-page--new",
    style: (_vm.getPageBgStyle())
  }, [_c('div', {
    staticClass: "foo"
  }, [(!_vm.hideTitle && _vm.showType !== 'ALL') ? _c('H1', [_vm._v(_vm._s(_vm.locale.t('label_pp_title')))]) : _vm._e(), _vm._v(" "), (_vm.showType === 'ALL') ? _c('div', {
    staticClass: "pp-all-header personal-user-details-page__all-header"
  }, [(_vm.showBackButton) ? _c('img', {
    staticClass: "clickable",
    attrs: {
      "src": require("../../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title title-flex-center"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e()], 1), _vm._v(" "), (_vm.showType !== 'ALL') ? _c('div', {
    staticClass: "wod-navigation personal-user-details-page__nav"
  }, [_c('div', {
    staticClass: "wod-arrow personal-user-details-page__nav-arrow",
    on: {
      "click": function($event) {
        return _vm.changeWeek(-1)
      }
    }
  }, [_c('i', {
    staticClass: "ti-angle-left"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDate),
      expression: "selectedDate"
    }],
    ref: "dateInput",
    staticClass: "personal-user-details-page__date-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.selectedDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedDate = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isMobile()) ? _c('div', {
    staticClass: "personal-user-details-page__date-display",
    on: {
      "click": function($event) {
        return _vm.openDatePicker()
      }
    }
  }, [_c('p', [_c('u', [_vm._v(_vm._s(_vm.currentWeek))])])]) : _vm._e(), _vm._v(" "), (_vm.isMobile()) ? _c('div', {
    staticClass: "personal-user-details-page__date-display",
    on: {
      "click": function($event) {
        return _vm.openDatePicker()
      }
    }
  }, [_c('p', [_c('u', [_vm._v(_vm._s(_vm.currentWeek))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "personal-user-details-page__calendar-trigger",
    on: {
      "click": function($event) {
        return _vm.openDatePicker()
      }
    }
  }, [_c('i', {
    staticClass: "ti-calendar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wod-arrow personal-user-details-page__nav-arrow",
    on: {
      "click": function($event) {
        return _vm.changeWeek(1)
      }
    }
  }, [_c('i', {
    staticClass: "ti-angle-right"
  })])]) : _vm._e(), _vm._v(" "), (_vm.groups.length > 0) ? _c('div', {
    staticClass: "w-full"
  }, [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "scrollmenuStart scrollmenu--single-row personal-user-details-page__groups"
  }, _vm._l((_vm.groups), function(group) {
    return _c('div', {
      class: _vm.selectedGroup === group ? 'personal-button-selected' : 'personal-button',
      on: {
        "click": function($event) {
          _vm.selectedGroup = group
        }
      }
    }, [_vm._v("\n          " + _vm._s(group) + "\n        ")])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wod-container"
  }, _vm._l(([0]), function(item) {
    return _c('div', {
      staticClass: "personal-program-item personal-user-details-page__program-item"
    }, [(_vm.showType !== 'MONTH' && _vm.showType !== 'ALL') ? _c('div', {
      staticClass: "wod-header"
    }, [_vm._v("\n          " + _vm._s(_vm.getDayFromDate(_vm.week[item].date)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
      staticClass: "center-wrapper"
    }, [_c('my-loader', {
      staticClass: "centered-div"
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.visibleTrainings.length === 0) ? _c('div', {
      staticClass: "center-wrapper"
    }, [_c('div', {
      staticClass: "centered-div"
    }, [_c('p', {
      staticClass: "no-trainings"
    }, [_vm._v(_vm._s(_vm.locale.t('label_no_workouts')))]), _vm._v(" "), _c('img', {
      staticClass: "section-top",
      attrs: {
        "src": require("../../assets/img/icons/ic_no_trainings.png")
      }
    })])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.visibleTrainings.length > 0) ? _c('div', {
      staticClass: "personal-user-details-page__stories"
    }, _vm._l((_vm.groupedVisibleTrainings), function(group) {
      return _c('div', {
        key: group.key,
        staticClass: "personal-user-details-page__story-group",
        class: {
          'is-superset': group.isSuperSet
        }
      }, [(group.isSuperSet) ? _c('div', {
        staticClass: "personal-user-details-page__story-group-title"
      }, [_vm._v(_vm._s(group.superSetName))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "personal-user-details-page__story-group-items"
      }, _vm._l((group.items), function(detailsItem) {
        return _c('div', {
          key: 'story-' + detailsItem.id,
          staticClass: "personal-user-details-page__story",
          class: {
            'is-active': _vm.selectedTraining && _vm.selectedTraining.id === detailsItem.id
          },
          attrs: {
            "data-story-id": detailsItem.id
          },
          on: {
            "click": function($event) {
              return _vm.selectTraining(detailsItem)
            }
          }
        }, [_c('div', {
          staticClass: "personal-user-details-page__story-thumb-wrap"
        }, [(_vm.getTrainingThumb(detailsItem)) ? _c('img', {
          staticClass: "personal-user-details-page__story-thumb",
          attrs: {
            "src": _vm.getTrainingThumb(detailsItem)
          }
        }) : _c('div', {
          staticClass: "personal-user-details-page__story-fallback"
        }, [_c('i', {
          staticClass: "ti-control-play"
        })]), _vm._v(" "), (_vm.isTrainingDone(detailsItem)) ? _c('div', {
          staticClass: "personal-user-details-page__story-done"
        }, [_c('i', {
          staticClass: "ti-check"
        })]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "personal-user-details-page__story-title"
        }, [_vm._v(_vm._s(_vm.getName(detailsItem)))])])
      }), 0)])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.selectedTraining) ? _c('div', {
      staticClass: "perosnal-content personal-user-details-page__card"
    }, [_c('div', {
      staticClass: "perosnal-content-title personal-user-details-page__card-title",
      on: {
        "click": function($event) {
          return _vm.playVideo(_vm.selectedTraining)
        }
      }
    }, [_vm._v(_vm._s(_vm.getName(_vm.selectedTraining)) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "perosnal-content-desc personal-user-details-page__card-subtitle"
    }, [_vm._v(_vm._s(_vm.getShortDesc(_vm.selectedTraining)))]), _vm._v(" "), (_vm.selectedTraining.collapsed == null || _vm.selectedTraining.collapsed === false) ? _c('div', {
      staticClass: "perosnal-content"
    }, [_c('div', {
      class: _vm.selectedTraining.showFullText === true || !_vm.hasVideoOrImage(_vm.selectedTraining) ? 'personal-text-container show-full' : 'personal-text-container',
      on: {
        "click": function($event) {
          _vm.selectedTraining.showFullText = !_vm.selectedTraining.showFullText
        }
      }
    }, [_c('p', {
      staticClass: "note-text"
    }, [_vm._v(_vm._s(_vm.getLongDesc(_vm.selectedTraining)))]), _vm._v(" "), (!_vm.selectedTraining.showFullText && _vm.hasVideoOrImage(_vm.selectedTraining)) ? _c('div', {
      staticClass: "personal-text-overlay"
    }) : _vm._e()]), _vm._v(" "), (_vm.hasVideoOrImage(_vm.selectedTraining)) ? _c('div', {
      staticClass: "personal-preview-image"
    }, [(_vm.selectedTraining.imageUrl != null && _vm.selectedTraining.imageUrl.length > 0 && _vm.selectedTraining.playingVideo == null) ? _c('img', {
      staticClass: "cropped1 media-fill",
      attrs: {
        "src": _vm.selectedTraining.imageUrl
      }
    }) : _vm._e(), _vm._v(" "), (_vm.selectedTraining.playingVideo == null && _vm.selectedTraining.imageUrl != null) ? _c('div', {
      staticClass: "personal-preview-image-play-icon-bg",
      on: {
        "click": function($event) {
          return _vm.playVideo(_vm.selectedTraining)
        }
      }
    }, [_c('img', {
      staticClass: "personal-preview-image-play-icon",
      attrs: {
        "src": require("../../assets/img/icons/ic_play.png")
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.selectedTraining.playingVideo == null && _vm.selectedTraining.imageUrl == null && _vm.selectedTraining.videoUrl != null) ? _c('iframe', {
      staticClass: "media-fill-rounded",
      attrs: {
        "src": _vm.selectedTraining.videoUrl,
        "sandbox": "allow-scripts allow-same-origin allow-presentation allow-popups",
        "frameborder": "0",
        "allow": "accelerometer;  clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        "referrerpolicy": "strict-origin-when-cross-origin",
        "allowfullscreen": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.selectedTraining.playingVideo != null) ? _c('iframe', {
      staticClass: "media-fill-rounded",
      attrs: {
        "id": "videoIframe",
        "src": _vm.selectedTraining.playingVideo,
        "sandbox": "allow-scripts allow-same-origin allow-presentation allow-popups",
        "frameborder": "0",
        "allow": "accelerometer;  clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        "referrerpolicy": "strict-origin-when-cross-origin",
        "allowfullscreen": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTraining.resultMeasure === 'IMAGE' && !_vm.selectedTraining.isLoadingResults) ? _c('div', [(_vm.selectedTraining.choosedImagePreview == null && _vm.selectedTraining.results[0] != null && _vm.selectedTraining.results[0].userImage == null) ? _c('div', [_c('button', {
      staticClass: "add-card",
      on: {
        "click": function($event) {
          return _vm.openChooser(_vm.selectedTraining.id)
        }
      }
    }, [_c('div', {
      staticClass: "plus"
    }, [_vm._v("＋")])]), _vm._v(" "), _c('input', {
      ref: 'fileInput_' + _vm.selectedTraining.id,
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          return _vm.onFileSelected($event, _vm.selectedTraining)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.selectedTraining.choosedImagePreview != null && _vm.selectedTraining.results[0] != null && _vm.selectedTraining.results[0].userImage == null) ? _c('div', [(_vm.selectedTraining.choosedImagePreview) ? _c('div', {
      staticClass: "preview"
    }, [_c('img', {
      staticClass: "training-result-preview-img",
      attrs: {
        "src": _vm.selectedTraining.choosedImagePreview,
        "alt": "Preview"
      }
    }), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn save personal-user-details-page__media-btn personal-user-details-page__media-btn--save",
      on: {
        "click": function($event) {
          return _vm.uploadImageBeforeSaveResults(_vm.selectedTraining)
        }
      }
    }, [_vm._v(" 💾 " + _vm._s(_vm.locale.t('label_save')))]), _vm._v(" "), _c('button', {
      staticClass: "btn delete personal-user-details-page__media-btn personal-user-details-page__media-btn--delete",
      on: {
        "click": function($event) {
          return _vm.removeImage(_vm.selectedTraining)
        }
      }
    }, [_vm._v(" ✖ " + _vm._s(_vm.locale.t('label_delete')))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTraining.results[0] != null) ? _c('div', [(_vm.selectedTraining.results[0].userImage != null) ? _c('div', {
      staticClass: "preview"
    }, [_c('img', {
      staticClass: "training-result-preview-img",
      attrs: {
        "src": _vm.selectedTraining.results[0].userImage,
        "alt": "Preview"
      }
    }), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn delete personal-user-details-page__media-btn personal-user-details-page__media-btn--delete",
      on: {
        "click": function($event) {
          return _vm.removeUserImage(_vm.selectedTraining)
        }
      }
    }, [_vm._v(" ✖ " + _vm._s(_vm.locale.t('label_delete')))])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTraining.resultMeasure !== 'IMAGE') ? _c('div', [_vm._l((_vm.selectedTraining.resultRounds), function(i) {
      return _c('div', {
        key: i,
        staticClass: "set-container"
      }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_result_set')) + " #" + _vm._s(i) + "\n                "), (_vm.selectedTraining.results[i - 1] != null) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedTraining.results[i - 1].quantity),
          expression: "selectedTraining.results[i-1].quantity"
        }],
        staticClass: "set-input",
        attrs: {
          "type": "number",
          "placeholder": _vm.locale.t('label_result_repeat')
        },
        domProps: {
          "value": (_vm.selectedTraining.results[i - 1].quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.selectedTraining.results[i - 1], "quantity", $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v(" -\n                "), (_vm.selectedTraining.results[i - 1] != null) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedTraining.results[i - 1].weight),
          expression: "selectedTraining.results[i-1].weight"
        }],
        staticClass: "weight-input",
        attrs: {
          "type": "number",
          "placeholder": _vm.selectedTraining.resultMeasure
        },
        domProps: {
          "value": (_vm.selectedTraining.results[i - 1].weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.selectedTraining.results[i - 1], "weight", $event.target.value)
          }
        }
      }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.selectedTraining.resultMeasure) + "\n              ")])
    }), _vm._v(" "), (!_vm.selectedTraining.isLoadingResults && _vm.isAllResultSet(_vm.selectedTraining) && _vm.selectedTraining.resultRounds != null && _vm.selectedTraining.resultRounds > 0) ? _c('div', {
      staticClass: "personal-button-selected result-save-btn",
      on: {
        "click": function($event) {
          return _vm.saveResults(_vm.selectedTraining)
        }
      }
    }, [_c('i', {
      staticClass: "ti-save"
    }), _vm._v("\n                 " + _vm._s(_vm.locale.t('label_save')) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.selectedTraining.isLoadingResults && !_vm.isAllResultSet(_vm.selectedTraining) && _vm.selectedTraining.resultRounds != null && _vm.selectedTraining.resultRounds > 0) ? _c('div', {
      staticClass: "personal-button-selected-disabled result-save-btn"
    }, [_c('i', {
      staticClass: "ti-save"
    }), _vm._v("\n                 " + _vm._s(_vm.locale.t('label_save')) + "\n              ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.selectedTraining.isLoadingResults) ? _c('div', {
      staticClass: "result-loader-pad"
    }, [(_vm.selectedTraining.isLoadingResults) ? _c('my-loader') : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTraining.collapsed === true) ? _c('div', {
      staticClass: "personal-user-details-page__completed",
      on: {
        "click": function($event) {
          return _vm.updateCollapsed(_vm.selectedTraining)
        }
      }
    }, [_c('p', [_c('i', {
      staticClass: "ti-check icon-success"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_completed')) + " "), _c('i', {
      staticClass: "ti-arrow-circle-down"
    })])]) : _vm._e()]) : _vm._e()])
  }), 0), _vm._v(" "), _c('play-video-dialog', {
    attrs: {
      "show": _vm.showPlayVideo,
      "item": _vm.itemToShow
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-175e97c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Personal/PersonalUserDetailsProgramNew.vue
// module id = 713
// module chunks = 0